/** Turn firehose base URL (http/https) into the CLI WebSocket URL. */
export function buildFirehoseCliWsUrl(baseUrl: string): string {
  const base = baseUrl.startsWith('https')
    ? baseUrl.replace(/^https/, 'wss')
    : baseUrl.replace(/^http/, 'ws');
  return `${base.replace(/\/$/, '')}/ws`;
}
